<template>
  <div class="popup-download">
    <div class="loading-upload-xml" v-show="loadingUploadDoc">
      <div class="preloader preloader-preload-xml">
        <svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
          <circle cx="170" cy="170" r="160" stroke="#4E53E7"/>
          <circle cx="170" cy="170" r="135" stroke="#404041"/>
          <circle cx="170" cy="170" r="110" stroke="#4E53E7"/>
          <circle cx="170" cy="170" r="85" stroke="#404041"/>
        </svg>
      </div>
    </div>
    <div v-show="!loadingUploadDoc">
      <div class="popup-header">
        <h4 class="title">Загрузить</h4>
      </div>
      <div class="download-content">
        <div class="download-scroll">
          <div class="doc-item" v-if="documents.length == 0">
            <div class="doc-info">
              <span class="doc-title">Выберите документы</span>
            </div>
          </div>
          <div class="doc-item" v-for="(item, index) in documents" :key="item.name">
            <div class="doc-info">
              <span class="doc-title">{{ item.name }}</span>
              <span class="doc-format">{{ Math.round(item.size / 1000) / 1000}} Мб</span>
            </div>
            <button>
              <img src="@img/trash.svg" alt="" @click="deleteItem(index)">
            </button>
          </div>
        </div>
        <input class="upload-file-input" type="file" name="file" id="file" multiple ref="newFiles" :value="filelist" accept=".zip" @change="newUpload()">
        <label class="add-file" for="file"><span>+</span>Добавить файл</label>
      </div>
      <div class="popup-footer upload-footer">
        <button class="btn-back" @click="cancelDownload">Отмена</button>
        <button class="btn accent-btn" @click="submit">Загрузить</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import AWS from 'aws-sdk'
export default {
  data () {
    return {
      url: '',
      loading: false,
      successAlert: false,
      files: null,
      documents: [],
      uploadDoc: false,
      progress: [],
      filelist: null,
      upload_progress: false,
      bucket: 'xml',
      s3: null,
      fileChooser: null,
      reader: null,
      loadingUploadDoc: false
    }
  },
  methods: {
    cancelDownload () {
      this.$emit('cancelDownload')
    },

    deleteItem (index) {
      this.documents.splice(index, 1)
    },

    newUpload () {
      for (let elem of this.$refs.newFiles.files) {
        let duplicateDoc = this.documents.find(item => { // поиск дублирующихся документов
          return elem.name === item.name
        })
        if (elem.type !== 'application/x-zip-compressed' && elem.type !== 'application/zip' && elem.type !== 'application/octet-stream' && elem.type !== 'application/x-zip') {
          this.$notify({
            group: 'foo',
            type: "error",
            title: "Загрузка документа",
            text: "Документ должен быть .zip",
          })
        } else if (duplicateDoc !== undefined) {
          this.$notify({
            group: 'foo',
            type: "error",
            title: "Загрузка документа",
            text: "Этот документ уже был загружен",
          })
        } else {
          this.documents.push(elem)
        }
      }
      document.getElementById('file').value = null
    },

    uploadToMinioAndServer (bucket, file, url) {
      this.loadingUploadDoc = true
      if (file) {
        // console.log(file)
        var s3Client = new AWS.S3({
          endpoint: this.$store.getters.value('minioHost'),
          accessKeyId: 'admin',
          secretAccessKey: 'itt0root',
          s3BucketEndpoint: true,
          s3ForcePathStyle: true,
          signatureVersion: 'v4',
          logger: window.console,
        })
        var self = this
        var managedUpload = s3Client.upload({
            Bucket: bucket,
            Key: file.name,
            Body: file,
        }, {}, function(err, data) {
            if (err) {
              console.log('errror upload file to minio: ', err)
              this.loadingUploadDoc = false
              self.$notify({
                group: 'foo',
                type: "error",
                title: "Загрузка документа",
                text: "Документ " + file.name + ' не загружен',
              })
              return
            }
            var _data = {
              "storage_url": data.Location,
              "storage_bucket": data.Bucket,
              "storage_fields": ["all"]
            }
            let axiosConfig = {
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              }
            }
            self.axios.post(url, _data, axiosConfig).then((response) => {
              console.log('response', response)
              self.$notify({
                group: 'foo',
                type: "success",
                title: "Загрузка документа",
                text: "Документ " + file.name + ' загружен',
              })
              self.succUploadDoc = true
              self.loadingUploadDoc = false
            }).catch(error => {
              self.$notify({
                group: 'foo',
                type: "error",
                title: "Загрузка документа",
                text: "Документ " + file.name + ' не загружен',
              })
              self.loadingUploadDoc = false
              console.log('error_status', error)
            })
        });
      }
    },
    submit () {
      this.uploadDoc = false
      this.progress = []
      this.listControl = new Array(this.documents.length)
      this.upload_progress = true
      var url = this.$store.getters.value('host') + '/converter/import/'
      for (let i = 0; i < this.documents.length; i++) {
        this.progress.push({'name': this.documents[i].name, 'progress': 0})
        this.loading = true
        this.uploadToMinioAndServer(this.bucket, this.documents[i], url)
      }
      this.upload_progress = false
      this.documents = []
    }
  }
}
</script>

<style lang="scss">
.popup-download {
  padding: 35px 0 35px 50px;
}
.download-content {
  padding-top: 20px;
  .download-scroll {
    max-height: 300px;
    padding: 0 15px;
    overflow-y: auto;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #cccccc;
      border-radius: 3px;
    }
  }
  .doc-item {
    width: 480px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
    span {
      display: block;
    }
    .doc-info {
      flex: none;
      max-width: 350px;
      width: 100%;
      font-size: 14px;
      margin-right: 65px;
    }
    .doc-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .doc-format {
      margin-top: 5px;
      font-size: 12px;
      color: #a6a6a6;
    }
  }
  .upload-file-input{
    width: 0px;
    height: 0px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
  .add-file {
    cursor: pointer;
    display: block;
    padding: 15px;
    border-radius: 10px;
    margin-top: 20px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    border: 1px dashed #e6e6e6;
    color: #4E53E7;
    transition: .3s;
    &:hover {
      border-color: #4E53E7;
    }
    span {
      display: inline-block;
      vertical-align: bottom;
      margin-right: 5px;
      font-size: 24px;
    }
  }
}
.upload-footer {
  padding-right: 0;
}
.preloader-preload-xml {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 8px;
  .loader {    
    top: 8px;
    left: 24%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PopupDownloadVue.vue